import Amendment from "./lease_details/amendment/pages";
import Obligations from "./lease_details/obligations/pages";
import OperatingRegion from "./lease_details/operating_region_esc/pages";
import Supplement from "./lease_details/supplement/pages";
import WorkingGroups from "./lease_details/working_groups/pages";
import Parties from "./lease_details/parties/pages";
import InsuranceClaim from "./lease_details/insurance_claim/pages";
import Leases from "./leases/pages";
import Contributions from "./lease_details/contributions/pages";
import PartyRole from "./settings/Role/pages";
import Clause from "./settings/Clause/pages/Clause";
import SecurityAgainst from "./settings/security_against/pages";
import ExceptionToAcceptance from "../lease_management/lease_details/exception_to_acceptance/pages"
import EolOptions from "./lease_details/eol_options/pages";
import QualifiedMaintenanceEvents from "./lease_details/qualified_maintenance_events/pages";
import EOLObligation from "./lease_details/eol_obligation/pages";
import LatePaymentInterest from "./lease_details/late_payment_interest/pages";
import RelatedLoans from "./lease_details/related_loans/pages";
import InductionCondition from "./lease_details/induction_condition/pages";
import ReserveRates from "../lease_management/reserve_rate/pages";
import Sublease from "./lease_details/sublease/pages";
import Redelivery from "./lease_details/redelivery/pages";
import WetLease from "./lease_details/wet_lease/pages";
import Utilizations from "./utilizations/pages";
import { UtilizationCRU } from "./utilizations/components";
import FleetUtilization from "./utilizations/pages/FleetUtilization";
import Headlines from "./lease_details/headlines/pages";
import RentalRates from "./rental_rates/pages";
import AssetsDetails from "./asset_details/lease_info/page";
import Assets from "./asset_listing/pages";
import Mou from "./asset_details/mou/pages";
import FleetInvoices from "./invoices/pages/FleetInvoices";
import LeaseInvoices from "./invoices/pages/LeaseInvoices";
import ShopVisit from "./shop_visit/pages";
import DeliveryCondition from "./lease_details/delivery_condition/pages";
import SecurityDeposit from "./lease_details/security_deposit/pages";
import Notification from "./header_action/notification/pages";
// import Faq from "./header_action/faq/pages"; // temporarily removed from routing
import Faq from "./header_action/faq/pages/FaqNew";
import WhatsNew from "./header_action/whats-new/pages";
import ReferenceDocuments from "./reference_documents/pages";
import ShopVisitView from "./shop_visit/pages/ShopVisitView";
import DashBoard from "./dashboard/pages";
import LeaseCashflow from "./cashflow/pages/LeaseCashflow"
import FleetCashflow from "./cashflow/pages/FleetCashflow"
import FinancingDetails from "./asset_details/financing_details/pages";
import SystemDocuments from "./system_documents/pages";
import SystemDocumentsSubModules from "./system_documents/pages/SystemDocumentsSubModules";
import UpcomingEvents from "./upcoming_events/pages";
import LeaseSettings from "./lease_settings/pages";
import AlertNotification from "./alert_notification/pages";
import Activites from "./activities/pages";
// import CashAccrual from "./cash_accrual/pages"; // temporarily removed from routing
import Reports from "./Reports/pages";
import SystemDocumentsTable from "./system_documents/components/systemDocumentsTable";
import Statistics from "./statistics/pages";
import ClaimManagement from "./claim_management/pages";
import CashFlowCategories from "./settings/cashflow_categories/pages";
import MRFundReport from "./mr_fund_report/pages";
import ReconcileInvoice from "./reconcile_invoice/pages";
import FleetClaimManagement from "./claim_management/pages/FleetClaimManagement";
import reconcileInvoiceView from "./reconcile_invoice/pages/reconcileInvoiceView";
import LoanAmortization from "./asset_details/loan_Amortization/page";
import Notes from "./lease_details/lease_notes/pages";
import Calender from "./settings/calender/pages";
import CalenderDetails from "./settings/calender/pages/CalenderDetails";
import InsuranceType from "./settings/insurance_type/pages";
import InvoiceDetailPage from "./invoices/pages/InvoiceDetailPage";
// import CustomFields from "./settings/custom_fields/pages"; // temporarily removed from routing
import FleetActivities from "./activities/pages/FleetActivities";
import Analytics from "./analytics/pages";
import AccountType from "./settings/AccountType/pages";
import AdditionalTaxes from "./additional_tax/pages/AdditionalTaxes";
import WorkingGroup from "./settings/working_group/pages";
import { getGlobalCookie } from '../utils';
import AdditionalTaxType from "./settings/AdditionalTaxType/Pages";
import InvoiceConfiguration from "./settings/invoice_configuration/pages";
import ChartOfAccount from "./settings/chart_of_account/pages";
import ProductAndServices from "./settings/product_and_services/pages";
import ConsentUsers from "../AIChatBot/ConsentUsers";
import ThirdPartyLanding from "./quickBooks/ThirdPartyLanding";
// import AIChatScreen from "../shared_elements/components/AIChatScreen";
import RentalFundReport from "./rental_fund_report/pages";
import FleetAlertNotification from "./alert_notification/pages/FleetAlertNotification";
import ContractAnalytics from "./contract_analytics/pages";

const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess') || 'null');
const displayForTestLessor = lessorAccess?.id === 13;

export const leaseRoutes = [
  {
    path: "/leases",
    component: Leases,
    key: "leases",
  },
  {
    path: "/assets",
    component: Assets,
    key: "assets"
  },
  {
    path: "/assets/:basic_info/:asset_type/:asset_slug/leases",
    component: AssetsDetails,
    key: "assets"
  },
  {
    path: "/assets/:basic_info/:asset_type/:asset_slug/mou",
    component: Mou,
    key: "mou"
  },
  {
    path: "/assets/:basic_info/:asset_type/:asset_slug/financing-details",
    component: FinancingDetails,
    key: "financing-details"
  },
  {
    path: "/invoices",
    component: FleetInvoices,
    key: "invoices",
  },
  {
    path: "/invoices/view/:slug",
    component: InvoiceDetailPage,
    key: "invoices",
  },
  {
    path: "/summary-invoices/:slug",
    component: InvoiceDetailPage,
    key: "invoices",
  },
  {
    path: "/lease/:leaseSlug/lease-details/supplement",
    component: Supplement,
    key: "supplement",
  },
  {
    path: "/lease/:leaseSlug/lease-details/obligations",
    component: Obligations,
    key: "obligations",
  },
  {
    path: "/lease/:leaseSlug/lease-details/eol-obligation",
    component: EOLObligation,
    key: "eol-obligations",
  },
  {
    path: "/lease/:leaseSlug/lease-details/delivery-condition",
    component: DeliveryCondition,
    key: "delivery-condition",
  },
  {
    path: "/lease/:leaseSlug/lease-details/return-condition",
    component: Redelivery,
    key: "return-condition",
  },
  {
    path: "/lease/:leaseSlug/lease-details/amendment",
    component: Amendment,
    key: "amendment",
  },
  {
    path: "/lease/:leaseSlug/lease-details/operating-region",
    component: OperatingRegion,
    key: "operating-region",
  },
  {
    path: "/lease/:leaseSlug/lease-details/parties",
    component: Parties,
    key: "parties",
  },
  {
    path: "/lease/:leaseSlug/lease-details/contributions",
    component: Contributions,
    key: "contributions",
  },
  {
    path: "/lease/:leaseSlug/lease-details/sublease",
    component: Sublease,
    key: "sublease",
  },
  {
    path: "/settings/party-role",
    component: PartyRole,
    key: "party-role",
  },
  {
    path: "/settings/clause",
    component: Clause,
    key: "clause",
  },
  {
    path: "/settings/security-against",
    component: SecurityAgainst,
    key: "security-against",
  },
  {
    path: "/settings/cashflow-categories",
    component: CashFlowCategories,
    key: "cashflow-categories",
  },
  {
    path: "/settings/calendar",
    component: Calender,
    key: "Calender",
  },
  {
    path: "/settings/insurance-type",
    component: InsuranceType,
    key: "insurance-type",
  },
  {
    path: "/settings/rate-account-type",
    component: AccountType,
    key: "rate-account-type",
  },
  ...(displayForTestLessor ? [{ 
    path: "/settings/working-group", 
    component: WorkingGroup, 
    key: "working-group", }, ] : []),
  {
    path: "/settings/additional-tax-type",
    component: AdditionalTaxType,
    key: "additional-tax-type",
  },
  {
    path: "/settings/invoice-configuration",
    component: InvoiceConfiguration,
    key: "invoice-configuration",
  },
  {
    path: "/settings/ai-consent",
    component: ConsentUsers,
    key: "ai-consent",
  },
  // {
  //   path: "/settings/custom-fields",
  //   component: CustomFields,
  //   key: "custom-fields",
  // },
  {
    path: "/settings/chart-of-account",
    component: ChartOfAccount,
    key: "chart-of-account"
  },
  {
    path: "/settings/product-services",
    component: ProductAndServices,
    key: "product-service"
  },
  {
    path: "/settings/alert-notification",
    component: FleetAlertNotification,
    key: "alert-notification"
  },
  {
    path: "/qb-third-party",
    component: ThirdPartyLanding,
    key: "chart-of-account"
  },
  {
    path: "/lease/:leaseSlug/lease-details/insurance",
    component: InsuranceClaim,
    key: "insurance",
  },
  {
    path: "/lease/:leaseSlug/lease-details/working-groups",
    component: WorkingGroups,
    key: "working-groups",
  },
  {
    path: "/lease/:leaseSlug/lease-details/exception_to_acceptance",
    component: ExceptionToAcceptance,
    key: "exception_to_acceptance",
  },
  {
    path: "/lease/:leaseSlug/lease-details/late_payment_interest",
    component: LatePaymentInterest,
    key: "late_payment_interest",
  },
  {
    path: "/lease/:leaseSlug/lease-details/eol-option",
    component: EolOptions,
    key: "eol-option",
  },
  {
    path: "/lease/:leaseSlug/lease-details/qualified-maintenance-events",
    component: QualifiedMaintenanceEvents,
    key: "qualified-maintenance-events",
  },
  {
    path: "/lease/:leaseSlug/lease-details/late-payment-interest",
    component: LatePaymentInterest,
    key: "late-payment-intrest",
  },
  {
    path: "/lease/:leaseSlug/lease-details/related-loans",
    component: RelatedLoans,
    key: "related-loans",
  },
  {
    path: "/lease/:leaseSlug/lease-details/induction-condition",
    component: InductionCondition,
    key: "induction-condition",
  },
  {
    path: "/lease/:leaseSlug/reserve-rates",
    component: ReserveRates,
    key: "reserve-rates",
  },
  {
    path: "/lease/:leaseSlug/lease-details/wet-lease",
    component: WetLease,
    key: "wet-lease",
  },
  {
    path: "/lease/:leaseSlug/utilization",
    component: Utilizations,
    key: "utilization",
  },
  {
    path: "/lease/:leaseSlug/utilization/:mode/:utilSlug",
    component: UtilizationCRU,
    key: "utilizations-cru",
  },
  {
    path: "/utilization",
    component: FleetUtilization,
    key: "fleet-utilizations",
  },
  {
    path: "/lease/:leaseSlug/rental-rates",
    component: RentalRates,
    key: "rental-rates",
  },
  {
    path: "/lease/:leaseSlug/lease-details/headlines",
    component: Headlines,
    key: "headlines",
  },
  {
    path: "/lease/:leaseSlug/lease-details/notes",
    component: Notes,
    key: "notes",
  },
  {
    path: "/lease/:leaseSlug/invoices",
    component: LeaseInvoices,
    key: "invoices"
  },
  {
    path: "/lease/:leaseSlug/shop-visit",
    component: ShopVisit,
    key: "shop-visit"
  },
  {
    path: "/lease/:leaseSlug/shop-visit/view/:slug",
    component: ShopVisitView,
    key: "shop-visit-view",
  },
  {
    path: "/lease/:leaseSlug/lease-details/security-deposit",
    component: SecurityDeposit,
    key: "security-deposit"
  },
  {
    path: "/notification",
    component: Notification,
    key: "notification"
  },
  {
    path: "/faq",
    component: Faq,
    key: "faq"
  },
  {
    path: "/whats-new",
    component: WhatsNew,
    key: "whats-new"
  },
  {
    path: "/lease/:leaseSlug/system-documents",
    component: SystemDocuments,
    key: "system-documents"
  },
  {
    path: "/lease/:leaseSlug/system-document/:module",
    component: SystemDocumentsTable,
    key: "system-files"
  },
  {
    path: "/lease/:leaseSlug/system-document/:module/assemblies",
    component: SystemDocumentsSubModules,
    key: "system-assemblies"
  },
  {
    path: "/lease/:leaseSlug/system-document/:module/assemblies/:assemblySlug",
    component: SystemDocumentsTable,
    key: "system-assembly-files"
  },
  {
    path: "/lease/:leaseSlug/upcoming-events",
    component: UpcomingEvents,
    key: "upcoming-events"
  },
  // {
  //   path: "/lease/:leaseSlug/cash-accrual",
  //   component: CashAccrual,
  //   key: "cash-accrual"
  // },
  {
    path: "/lease/:leaseSlug/reference-documents",
    component: ReferenceDocuments,
    key: "reference-documents"
  },
  {
    path: "/dashboard",
    component: DashBoard,
    key: "dashboard",
  },
  {
    path: "/lease/:leaseSlug/cashflow",
    component: LeaseCashflow,
    key: "cashflow"
  },
  {
    path: "/cashflow",
    component: FleetCashflow,
    key: "cashflow"
  },
  {
    path: "/reports",
    component: Reports,
    key: "reports"
  },
  {
    path: "/lease/:leaseSlug/lease-settings",
    component: LeaseSettings,
    key: "lease-settings"
  },
  {
    path: "lease/:leaseSlug/alert-notification",
    component: AlertNotification,
    key: "alert-notification"
  },
  {
    path: "lease/:leaseSlug/activities",
    component: Activites,
    key: "activities"
  },
  {
    path: "activities",
    component: FleetActivities,
    key: "fleet-activities"
  },
  {
    path: "lease/:leaseSlug/statistics",
    component: ContractAnalytics,
    key: "Statistics"
  },
  {
    path: "lease/:leaseSlug/claim-management",
    component: ClaimManagement,
    key: "claim-management"
  },
  {
    path: "claims",
    component: FleetClaimManagement,
    key: "claim-management"
  },
  {
    path: "/lease/:leaseSlug/mr-report-balance",
    component: MRFundReport,
    key: "mr-report"
  },
  {
    path: "/lease/:leaseSlug/mr-report-receivable",
    component: MRFundReport,
    key: "mr-report-receivable"
  },
  {
    path: "/lease/:leaseSlug/rental-report-balance",
    component: RentalFundReport,
    key: "rental-report"
  },
  {
    path: "/lease/:leaseSlug/rental-report-receivable",
    component: RentalFundReport,
    key: "rental-report-receivable"
  },
  {
    path:'/lease/:leaseSlug/additional-tax',
    component:AdditionalTaxes,
    key:'additional_tax'
  },
  { 
    path: "/lease/:leaseSlug/reconcile-invoices",
    component: ReconcileInvoice,
    key: "reconcile-invoices"
  },
  {
    path: "/lease/:leaseSlug/reconcile-invoices-view/:slug",
    component: reconcileInvoiceView,
    key: "reconcile-invoices-view",
  },
  // {
  //   path: "lease/:leaseSlug/statistics-normal",
  //   component: StatisticsOld,
  //   key: "Statistics"
  // },
  {
    path: "/assets/:basic_info/:asset_type/:asset_slug/loan-amortization",
    component: LoanAmortization,
    key: "loan-amortization"
  },
  {
    path: "/settings/calendar/view/:slug",
    component: CalenderDetails,
    key: "calender",
  },
   {
    path: "/analytics",
    component: Analytics,
    key: "analytics",
  },
  // {
  //   path:'ai-chat',
  //   component:AIChatScreen,
  //   key:'AIChatScreen'
  // }
];

export const leaseNavLinks = [
  { path: "statistics", label: "Statistics",hideWhenInactive: true },
  // { path: "contract-analytics", label: "Contract Analytics" },
  { path: "lease-details/headlines", label: "Lease Details", component: Headlines },
  { path: "rental-rates", label: "Rental Rates", component: RentalRates  },
  { path: "reserve-rates", label: "Reserve Rates", pageLabel: "Reserve Rate", component: ReserveRates },
  { path: "utilization", label: "Utilization",hideWhenInactive: true },
  { path: "invoices", label: "Invoices", pageLabel:'Invoices', component: LeaseInvoices, hideWhenInactive: true},
  { path: "additional-tax", label: "Additional Tax", pageLabel: 'Additional Tax', component: AdditionalTaxes, hideWhenInactive: true },
  { path: "reconcile-invoices", label: "Reconcile Invoices", pageLabel:'Reconcile Invoices', component: ReconcileInvoice,hideWhenInactive: true},
  { path: "cashflow", label: "Cashflow",hideWhenInactive: true },
  { path: "mr-report-balance", label: "MR Report", pageLabel: "MR Report", component: MRFundReport,hideWhenInactive: true },
  { path: "rental-report-balance", label: "Rental Report", pageLabel: "Rental Report", component: RentalFundReport, hideWhenInactive: true },
  { path: "shop-visit", label: "Shop Visit", pageLabel: "Shop Visit", component: ShopVisit,hideWhenInactive: true },
  { path: "claim-management", label: "Claim Management",hideWhenInactive: true },
  { path: "upcoming-events", label: "Upcoming Events",hideWhenInactive: true },
  // { path: "cash-accrual", label: "Cash Accrual",hideWhenInactive: true }, // temporarily removed from routing
  { path: "reference-documents", label: "Reference Documents" },
  { path: "system-documents", label: "System Documents",  pageLabel: "System Documents", component: SystemDocuments },
  { path: 'lease-settings', label: "Lease Settings" },
  { path: "alert-notification", label: "Alert & Notifications",component: AlertNotification },
  { path: "activities", label: "Activities" },
];
